import { Form } from 'antd';
import { I18n } from '@aws-amplify/core';

import { useGetCellules } from '@/hooks/useGetCellules';
import { SelectWithCreation } from '@/components/ui/Inputs';
import { hierarchyHandler } from '@/utils/hierarchy-handler';
import { HierarchiesField } from '@/utils/enum';
import { PlaceholderText } from './styles';

const { useFormInstance, useWatch } = Form;

export function Cellules(): JSX.Element {
	const form = useFormInstance();
	const fieldName = HierarchiesField.CELLULE;
	const sectorId = useWatch(HierarchiesField.SECTOR, form);
	const companyId = useWatch(HierarchiesField.COMPANY, form);
	const organizationId = useWatch(HierarchiesField.ORGANIZATION, form);

	const {
		isFetching: isGettingCellules,
		data: cellules,
		isError: errorGettingCellules
	} = useGetCellules({
		organization_id: organizationId,
		company_id: companyId,
		sector_id: sectorId
	});

	function handleOnChange(id: string): void {
		const fieldsToReset = hierarchyHandler.getHierarchiesFieldsToClear(fieldName);

		if (fieldsToReset && id) {
			form.resetFields(fieldsToReset);
			form.setFieldValue(fieldName, id);
		}
	}

	function handleOnClear(): void {
		const fieldsToReset = hierarchyHandler.getHierarchiesFieldsToClear(fieldName);
		fieldsToReset && form.resetFields(fieldsToReset);
	}

	const isDisabled = !sectorId || !cellules || errorGettingCellules;

	return (
		<Form.Item name={fieldName} label={I18n.get('Cell')} labelCol={{ span: 24 }}>
			<SelectWithCreation
				showSearch
				allowClear
				disabled={isDisabled}
				selectOptions={cellules}
				loading={isGettingCellules}
				onClear={handleOnClear}
				onChange={handleOnChange}
				placeholder={<PlaceholderText>Cellule</PlaceholderText>}
			/>
		</Form.Item>
	);
}
